<style lang="scss" scoped="">
  .el-form .el-select {
    display: block;
  }
</style>
<template>
  <div>
    <h2 class="clearfix">{{form.id ? '编辑' : '添加'}}仓库</h2>
    <el-form :model="form" :rules="rules" @submit.prevent="onSubmit('accountform')" label-width="100px"
             onsubmit="return false" ref="accountform">
      <el-form-item label="所属单位" style="margin-bottom: 0">
        {{currentItem.logisticsCompanyName}}
      </el-form-item>
      <el-form-item label="物流中心名称" style="margin-bottom: 0">
        {{currentItem.name}}
      </el-form-item>
      <el-form-item label="物流中心编码" style="margin-bottom: 0">
        {{currentItem.code}}
      </el-form-item>
      <el-form-item label="仓库名称" prop="name">
        <el-input placeholder="请输入仓库名称" v-model="form.name" :maxlength="100" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="仓库编码" prop="code">
        <el-input placeholder="请输入仓库编码" v-model="form.code" :maxlength="35" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label-width="100px">
        <el-button :disabled="doing" @click="onSubmit('accountform')" native-type="submit" type="primary">保存</el-button>
        <el-button @click="doClose">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {BspWarehouse} from '@/resources';
  import MethodsMix from '@/mixins/methodsMinix';

  export default {
    name: 'editForm',
    mixins: [MethodsMix],
    props: {
      formItem: {
        type: Object,
        required: true
      },
      show: {
        type: Boolean,
        default: true
      },
      currentItem: Object
    },
    data: function () {
      return {
        form: {
          logisticsCentreId: '',
          name: '',
          code: ''
        },
        rules: {
          name: [
            {required: true, message: '请输入仓库名称', trigger: 'blur'}
          ],
          code: [
            {required: true, message: '请输入仓库编码', trigger: 'blur'}
          ]
        },
        doing: false,
        logisticsCenter: [],
        keyList: []
      };
    },
    watch: {
      formItem: function (val) {
        this.keyList = [];
        this.$refs['accountform'].clearValidate();
        this.upOrgList = [];
        if (val.id) {
          this.form = Object.assign({}, this.formItem);
        } else {
          this.form = {
            logisticsCentreId: '',
            name: '',
            code: ''
          };
        }
      },
      show: function (val) {
        if (!val) {
          this.$refs['accountform'].resetFields();
        }
      }
    },
    methods: {
      onSubmit: function (formName) {
        this.$refs[formName].validate((valid) => {
          if (!valid || this.doing) {
            return false;
          }
          this.doing = true;
          if (!this.form.id) {
            this.form.logisticsCentreId = this.currentItem.id;
            BspWarehouse.save(this.form).then(() => {
              this.doing = false;
              this.$notify.success({
                duration: 2000,
                name: '成功',
                message: '新增成功'
              });
              this.$emit('change', this.currentItem);
            }).catch(error => {
              this.$notify.error({
                duration: 2000,
                message: error.response.data && error.response.data.msg || '新增失败'
              });
              this.doing = false;
            });
          } else {
            BspWarehouse.update(this.form).then(() => {
              this.doing = false;
              this.$notify.success({
                duration: 2000,
                name: '成功',
                message: '修改成功'
              });
              this.$emit('change', this.currentItem);
            }).catch(error => {
              this.$notify.error({
                duration: 2000,
                message: error.response.data && error.response.data.msg || '修改失败'
              });
              this.doing = false;
            });
          }
        });
      },
      doClose: function () {
        this.$emit('close');
      }
    }
  };
</script>
